import { getStyle } from './getStyle';
import * as React from 'react';
import { Text, View } from '@react-pdf/renderer';

export function getInhaltsverzeichnis(bookmarks: any): JSX.Element {
    return (
        <View>
            <Text style={{ ...getStyle('h1'), marginTop: '60pt', marginBottom: '20pt' }}>
                Inhaltsverzeichnis
            </Text>
            {Object.keys(bookmarks).map((key: string, index: number) =>
                <View
                    key={`inhaltsverzeichnis_${index}`}
                    style={{ ...getStyle(bookmarks[key].level === 1 ? 'katalog_l1' : bookmarks[key].level === 2 ? 'katalog_l2' : null) }}
                >
                    <View style={{
                        display: 'flex', flexDirection: 'row', width: '460pt',
                        ...(bookmarks[key].level > 1 ? { paddingLeft: '20pt' } : {})
                    }}>
                        <Text>{key}</Text>
                        <Text style={{ flex: 1, margin: '0 5pt', borderBottom: '1pt dotted #000', height: '9pt' }}></Text>
                    </View>
                    <Text>{bookmarks[key].page}</Text>
                </View>
            )}
        </View>
    );
}
